<template>
	<section class="date-time-cache-date-container">
		<CRow class="mb-4">
			<CCol md="12">
				<h4 class="search-weight-title">
					Clear all auto reset
				</h4>
				<div class="description typo-body-2 color-black-45">
					ตั้งค่ารีเซ็ตวันที่และเวลาล้างแคชแบบอัตโนมัติ
				</div>
			</CCol>
		</CRow>

		<CRow class="mb-4">
			<CCol md="10">
				<BaseInputDate
					v-model="startDateValue"
					label="Select date (optional)"
					placeholder="Select date"
				>
					<template #append-content>
						<CIcon class="cil-calendar" name="cil-calendar" />
					</template>
				</BaseInputDate>
			</CCol>
			<CCol md="2">
				<BaseInputTime
					v-model="$v.startTimeValue.$model"
					label="Select time"
					:is-valid="!$v.startTimeValue.$error"
					:invalid-feedback="errorStartTime"
				/>
			</CCol>
		</CRow>
	</section>
</template>

<script>
import BaseInputDate from '@/components/BaseInputDate.vue';
import BaseInputTime from '@/components/BaseInputTime.vue';

export default {
	name: 'DateTimeCacheDate',
	components: {
		BaseInputDate,
		BaseInputTime,
	},
	props: {
		/**
		 * วันที่สำหรับการล้างแคชอัตโนมัติ
		 */
		startDate: {
			type: [Date, String],
			default: null,
		},
		/**
		 * เวลาสำหรับการล้างแคชอัตโนมัติ (รูปแบบ HH:mm)
		 */
		startTime: {
			type: [String, Number],
			default: null,
		},
	},
	validations() {
		return {
			startTimeValue: {
				// ตรวจสอบความยาวของเวลา ให้อยู่ในรูปแบบ HH:mm (5 ตัวอักษร) หรือว่างเปล่า
				validTime(time) {
					return time.length === 5 || time.length === 0;
				},
			},
		};
	},
	computed: {
		/**
		 * Property สำหรับจัดการ v-model รูปแบบคล้าย 2-way binding ส่งค่าไปยัง Component แม่
		 */
		startDateValue: {
			get() {
				return this.startDate;
			},
			set(value) {
				this.$emit('update:startDate', value);
			},
		},

		/**
		 * Property สำหรับจัดการ v-model รูปแบบคล้าย 2-way binding ส่งค่าไปยัง Component แม่
		 */
		startTimeValue: {
			get() {
				return this.startTime;
			},
			set(value) {
				this.$emit('update:startTime', value);
			},
		},

		/**
		 * คืนค่าข้อความแจ้งเตือนหากรูปแบบเวลาไม่ถูกต้อง (ช่วยแก้ไขบั๊กจากโค้ดเดิม)
		 */
		errorStartTime() {
			// อ้างอิงตรวจสอบจากสถานะของ Vuelidate แทนการเช็คจาก property โดยตรงซึ่งไม่มีอยู่จริงใน String
			if (!this.$v.startTimeValue.validTime) {
				return 'รูปแบบเวลาไม่ถูกต้อง';
			}

			return null;
		},
	},
};
</script>

<style lang="scss" scoped>
.date-time-cache-date-container {
	padding-bottom: 42px;
}
</style>
